import { useSnackbar } from 'notistack';
import { useQuery } from 'react-query';
import { useService } from 'shared/providers';
import { Brands, CustomerTypeLookup, DropDownOption } from 'shared/types';

export function useCustomerTypes(brand: Brands) {
  const { quoteService } = useService();
  const { enqueueSnackbar } = useSnackbar();
  const { data, isLoading, isFetching } = useQuery<string[], Error>(
    ['customertypes', brand],
    () =>
      quoteService.getDropdownOptions<CustomerTypeLookup>({
        brand,
        table: 'marginadjustment',
        optionColumn: 'competitivefactor',
      }),

    {
      onError: error => {
        enqueueSnackbar(error.message, { variant: 'error' });
      },
      retry: false,
    }
  );
  const mappedTypes: DropDownOption[] = (data || []).map(type => ({ key: type, value: type }));
  return { types: mappedTypes, isLoading, isFetching } as const;
}
